import { AccordionFAQ, Guides } from '../components';  


function Learn() {
	
	return (
		<div className="flex flex-col">
			<Guides />
			
			<AccordionFAQ />
		</div>
	);
}

export default Learn;
